export enum UserEmailsQueryKeys {
  Me = '/user-emails/me',
  MeById = '/user-emails/me/:id',
}
